import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=2b7661fe&scoped=true&"
import script from "./Step1.vue?vue&type=script&lang=tsx&"
export * from "./Step1.vue?vue&type=script&lang=tsx&"
import style0 from "./Step1.vue?vue&type=style&index=0&id=2b7661fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7661fe",
  null
  
)

export default component.exports